import logoImg from '../assets/NAGARA_containerlogo.png';

function Footer() {
  return (
    <footer className="site-footer">
      <div className="container">

        <div className="footer-inner">

          <a href="/" className="footer-brand" aria-label="NAGARA container トップページへ戻る">
            <img src={logoImg} alt="" className="footer-brand-mark" />
            <span className="footer-logo">NAGARA container</span>
          </a>

          <nav className="footer-nav">
            <a href="/#types">タイプ一覧</a>
            <a href="/#chassis">シャーシ</a>
            <a href="/#yard">ヤード案内</a>
            <a href="/#column">コラム</a>
            <a href="/#company">会社概要</a>
            <a href="/#contact">お問い合わせ</a>
          </nav>
        </div>

        <div className="footer-bottom">
          <p>© 2026 NAGARA container</p>
        </div>

      </div>
    </footer>
  );
}

export default Footer;
